<!-- Dialogs -->
<ui-confirmation-dialog
    #completeAndPayConfirmation
    header="payroll.run.confirmAction"
    primaryButtonLabel="payroll.run.payNow"
    secondaryButtonLabel="cancel"
>
    <p>{{ 'payroll.run.areYouSureYouWantToPayPayrollThisCannotBeUndone' | translate }}</p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    #confirmDeleteDialog
    header="payroll.run.confirmAction"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
>
    <p>{{ 'payroll.run.areYouSureYouWishToPerformThisAction' | translate }}</p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    #terminatedSalaryConfirmation
    header="payroll.run.updateRoe"
    primaryButtonLabel="payroll.run.ok"
    secondaryButtonLabel="cancel"
>
    <div [innerHTML]="'payroll.run.terminatedSalaryConfirmation' | translate"></div>
</ui-confirmation-dialog>

<ui-dialog
    [open]="ameegoHumiImportErrorsModalShow"
    (closing)="ameegoHumiImportErrorsModalShow = false"
    size="medium"
    header="payroll.run.ameegoUploadErrorModalTitle"
>
    <app-simple-table
        [columns]="ameegoHumiImportErrorsModalColumns"
        [rows]="ameegoHumiImportErrorsModalRows"
    ></app-simple-table>
</ui-dialog>

<!-- Feedback modal appear when editPayrollAgGrid FF is enabled -->
<ui-dialog
    size="small"
    (closing)="isFeedbackModalOpen = false"
    [open]="isFeedbackModalOpen"
    header="{{ 'payroll.run.table.shareFeedback' | translate }}"
>
    <form class="responsive-grid" #feedbackform="ngForm">
        <mat-form-field>
            <textarea
                matInput
                rows="5"
                minlength="1"
                maxlength="1000"
                name="feedBackMessage"
                [(ngModel)]="feedBackMessage"
            ></textarea>
        </mat-form-field>
    </form>
    <div class="text-align-left">{{ 'payroll.run.table.characterLimitIsMaxlength' | translate: { max: 1000 } }}</div>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="isFeedbackModalOpen = false">{{
            'payroll.run.table.cancel' | translate
        }}</ui-button>
        <ui-button type="primary" (click)="submitFeedback()">{{ 'save' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<!-- Content -->
<div class="ui basic segment" [class.loading]="isLoading">
    <ng-container *ngIf="payroll">
        <app-header
            [title]="
                'payroll.records.details.payrollAndDate'
                    | translate: { date: payroll.chequeDate | i18nDate: 'shortWeekday' }
            "
            [subtitle]="
                'payroll.records.details.runByPayrollDeadline'
                    | translate: { date: payroll.deadline | i18nDate: 'shortWeekday' }
            "
            [back]="true"
            [backRoute]="['..']"
            [contextMenu]="!payroll.recurring"
        >
            <div class="buttons">
                <ng-container *ngIf="payroll.recurring && appSteps?.activeStep === stepIndices.editStep">
                    <ng-container>
                        <ui-button
                            type="outline"
                            [matMenu]="exportMenu"
                            [matMenuTriggerFor]="exportMenu"
                            (menuClosed)="toggleExportMenu()"
                            (menuOpened)="toggleExportMenu()"
                        >
                            {{ 'payroll.run.downloadTemplate' | translate }}
                            <mat-icon *ngIf="!expandExportMenu" svgIcon="chevronDown"></mat-icon>
                            <mat-icon *ngIf="expandExportMenu" svgIcon="chevronUp"></mat-icon>
                        </ui-button>
                        <mat-menu #exportMenu xPosition="before">
                            <button mat-menu-item (click)="downloadHoursTemplate()">
                                <mat-icon svgIcon="clock"></mat-icon>
                                {{ 'payroll.run.hoursTemplate' | translate }}
                            </button>
                            <button mat-menu-item (click)="downloadAdditionalIncomesTemplate()">
                                <mat-icon svgIcon="money"></mat-icon>
                                {{ 'payroll.run.dollarIncomesTemplate' | translate }}
                            </button>
                        </mat-menu>

                        <ui-button
                            type="primary"
                            [matMenu]="importMenu"
                            [matMenuTriggerFor]="importMenu"
                            (menuClosed)="toggleImportMenu()"
                            (menuOpened)="toggleImportMenu()"
                        >
                            {{ 'payroll.run.importPayrollData' | translate }}
                            <mat-icon *ngIf="!expandImportPayrollData" svgIcon="chevronDown"></mat-icon>
                            <mat-icon *ngIf="expandImportPayrollData" svgIcon="chevronUp"></mat-icon>
                        </ui-button>
                        <mat-menu #importMenu xPosition="before">
                            <button mat-menu-item (click)="uploadHours()">
                                <mat-icon svgIcon="clock"></mat-icon>
                                {{ 'payroll.run.hoursFromFile' | translate }}
                            </button>
                            <button mat-menu-item (click)="uploadAdditionalIncomes()">
                                <mat-icon svgIcon="money"></mat-icon>
                                {{ 'payroll.run.dollarIncomesFromFile' | translate }}
                            </button>
                            <ng-container *ngIf="ameegoHumiImport">
                                <button mat-menu-item (click)="uploadAmeegoHumiImport()">
                                    <mat-icon svgIcon="ameegoColour"></mat-icon>
                                    {{ 'payroll.run.ameegoHumiFromFile' | translate }}
                                </button>
                            </ng-container>
                        </mat-menu>
                    </ng-container>
                </ng-container>

                <ng-container
                    *ngIf="
                        schedule?.lastPaidPeriod !== undefined &&
                        schedule?.lastPaidPeriod !== null &&
                        appSteps?.activeStep === stepIndices.reviewStep
                    "
                >
                    <ui-button>
                        <a
                            [routerLink]="['/reporting', 'payroll', 'payroll-register']"
                            [queryParams]="{
                                payrollType: payroll?.recurring ? 'recurring' : 'off-cycle',
                                payPeriod: payroll?.recurring ? payroll?.periodNo : payroll?.chequeDate,
                                year: getYear(payroll?.chequeDate),
                            }"
                            target="_blank"
                            >{{ 'payroll.run.viewPayrollRegister' | translate }}</a
                        >
                    </ui-button>
                </ng-container>

                <ng-container
                    *ngIf="hasAgGridFeature && stepsComponent?.activeStep === stepIndices.editStep && showEditForm"
                >
                    <!-- Title -->
                    <ng-container [ngTemplateOutlet]="switchViewButton"></ng-container>
                    <ui-button type="outline" (click)="isFeedbackModalOpen = true">{{
                        'payroll.run.table.shareFeedback' | translate
                    }}</ui-button>
                </ng-container>
            </div>
            <app-context-item label="delete" (click)="onDelete()"> </app-context-item>
        </app-header>
        <app-steps
            #appSteps
            [class.lower-margin]="payroll.hasProrations"
            [steps]="(showHoursStep ? [hoursStep] : []).concat([editStep, reviewStep])"
            [activeStep]="initialStep"
            [beforeNext]="nextStepTransitionState"
            [beforePrevious]="previousStepTransitionState"
            [labels]="{
                primary: 'payroll.run.completeAndPay',
                previous:
                    showHoursStep && appSteps?.activeStep == stepIndices.editStep
                        ? 'payroll.run.hours'
                        : 'payroll.run.edit',
            }"
            [options]="{
                disableNavigation: disableUserFromClickingNextStep,
                disableFinish: isHoursUnlocked,
            }"
            (onPrimary)="onSave()"
        >
            <ui-banner
                *ngIf="isHoursUnlocked && appSteps?.activeStep == stepIndices.reviewStep"
                variant="danger"
                class="margin-top-4"
                ><p class="margin-0">{{ 'payroll.run.payPeriodMustBeLocked' | translate }}</p>
            </ui-banner>
            <ui-banner
                *ngIf="payroll.hasProrations && stepsComponent?.activeStep === stepIndices.editStep"
                type="proration"
                variant="warning"
            >
                <p class="margin-0">
                    {{ 'payroll.run.weHaveMadeProrationsForThisPayPeriodPleaseReviewToEnsureTheyreCo' | translate }}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://humi.zendesk.com/hc/en-us/articles/360048218113-How-Humi-Prorates-Regular-Pay"
                        >{{ 'payroll.run.learnMore' | translate }}</a
                    >
                </p>
            </ui-banner>

            <!-- Time worked import in progress warning -->
            <ui-banner *ngIf="importsInProcess.length > 0" variant="warning">
                <p class="margin-0" *ngIf="importsInProcess.length === 1">
                    {{ 'payroll.run.thereIsCurrentlyOneImportRunningFromSchedulingYouWillNotBeAbleTo' | translate }}
                </p>
                <p class="margin-0" *ngIf="importsInProcess.length > 1">
                    {{
                        'payroll.run.thereAreCurrentlyImportsInProcesslengthImportsRunningFromSchedul'
                            | translate
                                : {
                                      count: importsInProcess.length,
                                  }
                    }}
                </p>
            </ui-banner>

            <!-- Time worked import just finished warning -->
            <ui-banner *ngIf="importsJustFinished" variant="danger">
                <p class="margin-0">
                    {{ 'payroll.run.importsFromSchedulingHaveJustCompletedPlease' | translate }}
                    <a onclick="location.reload()">{{ 'payroll.run.reload' | translate }}</a
                    >{{ 'payroll.run.thePageToGetTheUpdatedData' | translate }}
                </p>
            </ui-banner>

            <!-- WCB backfill in progress warning -->
            <ui-banner *ngIf="isWcbBackfillInProgress" variant="warning">
                <p class="margin-0">
                    {{ 'payroll.run.workersCompensationActivationIsInProgressAndMayTakeAfewMinutesYo' | translate }}
                </p>
            </ui-banner>

            <!-- WCB backfill complete info banner -->
            <ui-banner
                *ngIf="wcbBackfillJustFinished"
                variant="success"
                [closable]="true"
                (close)="wcbBackfillJustFinished = false"
            >
                <p class="margin-0">{{ 'payroll.run.workersCompensationActivationIsComplete' | translate }}</p>
            </ui-banner>

            <!-- Ameego Payroll import errors modal -->
            <ui-banner *ngIf="ameegoHumiImportErrors.length > 0" variant="danger" (close)="ameegoHumiImportErrors = []">
                <p class="margin-0">{{ 'payroll.run.ameegoUploadContainsErrors' | translate }}</p>
                <div class="margin-left-auto">
                    <ui-button type="danger" (click)="ameegoHumiImportErrorsModalShow = true">{{
                        'payroll.run.ameegoUploadReviewErrors' | translate
                    }}</ui-button>
                </div>
            </ui-banner>
            @if (!hasAgGridFeature || (hasAgGridFeature && !showTableView)) {
                <div
                    class="payroll-search-filter-container"
                    *ngIf="stepsComponent?.activeStep === stepIndices.editStep && showEditForm"
                >
                    <app-filter [groups]="filterGroups" (filter)="onFilter()"></app-filter>
                    <app-search (onSearch)="onSearch($event)"></app-search>
                </div>
            }
            <app-step
                #editStep
                [stepForm]="showTableView ? editFormAgGrid : editForm"
                step="payroll.run.edit"
                [title]="showEditForm ? 'payroll.run.editPayroll' : ''"
            >
                <form #ngForm *ngIf="!payroll.recurring && showEditForm" class="add-employee-form">
                    <mat-form-field>
                        <ui-employee-autocomplete
                            placeholder="{{ 'payroll.run.addEmployee' | translate }}"
                            name="selectEmployee"
                            [(ngModel)]="addEmployee"
                            [customQuery]="offCycleCustomEmployeeQuery"
                            [statusDeterminer]="employeeStatusDeterminer"
                            #selectEmployee="ngModel"
                        ></ui-employee-autocomplete>
                    </mat-form-field>
                    <ui-button (click)="addPaystub()" [disabled]="!addEmployee" type="primary">{{
                        'payroll.run.add' | translate
                    }}</ui-button>
                </form>
                @if (showTableView) {
                    <app-form-payroll-edit-ag-grid
                        #editFormAgGrid
                        [payroll]="payroll"
                        [showForm]="showEditForm"
                        [externalFilters]="filterGroups"
                        [isParentLoading]="isLoading"
                        (disableUserFromClickingNextStepEmitter)="setNextStepDisabledState($event)"
                    ></app-form-payroll-edit-ag-grid>
                } @else {
                    <app-form-payroll-edit
                        #editForm
                        [payroll]="payroll"
                        [showForm]="showEditForm"
                        (payrollChange)="onPayrollChange()"
                        (sortDirectionChange)="onSort($event)"
                        (disableUserFromClickingNextStepEmitter)="setNextStepDisabledState($event)"
                    ></app-form-payroll-edit>
                }
                <ng-container *ngIf="!showEditForm">
                    <h2>{{ 'payroll.run.preparingPayroll' | translate }}</h2>
                    <p>{{ 'payroll.run.payrollIsBeingCalculatedYoullBeAbleToReviewShortly' | translate }}</p>

                    <div class="progress-bar">
                        <span class="progress-bar-label">{{ 'payroll.run.calculatingPayroll' | translate }}</span>
                        <span style="float: right">{{ getProgress() | i18nNum: '%' }}</span>
                        <mat-progress-bar
                            class="margin-top-1"
                            mode="determinate"
                            [value]="getProgress()"
                        ></mat-progress-bar>
                    </div>
                </ng-container>
            </app-step>

            <app-step #hoursStep [stepForm]="hoursForm" [embeddedCard]="false" step="payroll.run.hours">
                <app-payroll-hours-form
                    [payroll]="payroll"
                    [showForm]="showHoursForm"
                    #hoursForm
                    (onLoading)="isLoading = $event"
                    (onUnlocked)="isHoursUnlocked = $event"
                    (onHoursAssigned)="setHoursToggles()"
                ></app-payroll-hours-form>
                <ng-container *ngIf="!showHoursForm">
                    <ui-card>
                        <h2>{{ 'payroll.run.preparingPayroll' | translate }}</h2>
                        <p>{{ 'payroll.run.payrollIsBeingCalculatedYoullBeAbleToReviewShortly' | translate }}</p>

                        <div #progressBar class="progress-bar">
                            <span class="progress-bar-label">{{ 'payroll.run.calculatingPayroll' | translate }}</span>
                            <span style="float: right">{{ getProgress() | i18nNum: '%' }}</span>
                            <mat-progress-bar
                                class="margin-top-1"
                                mode="determinate"
                                [value]="getProgress()"
                            ></mat-progress-bar>
                        </div>
                    </ui-card>
                </ng-container>
            </app-step>

            <app-step
                #reviewStep
                [stepForm]="reviewForm"
                step="payroll.run.review"
                [title]="'payroll.run.reviewPayroll'"
            >
                <app-form-payroll-review #reviewForm [payroll]="payroll"></app-form-payroll-review>
            </app-step>

            <div #scrollAnchor class="flex justify-center">
                <mat-progress-spinner *ngIf="isLazyLoading" color="primary" mode="indeterminate" diameter="30">
                </mat-progress-spinner>
            </div>
        </app-steps>
    </ng-container>
</div>

<app-upload-hours style="display: none" #uploadHoursComponent (onFileUpload)="uploadHours($event)"></app-upload-hours>
<app-upload-csv
    name="fileSelectorIncomes"
    style="display: none"
    (onFileUpload)="uploadAdditionalIncomes($event)"
></app-upload-csv>
<app-upload-csv
    name="fileSelectorAmeegoHumi"
    style="display: none"
    (onFileUpload)="uploadAmeegoHumiImport($event)"
></app-upload-csv>
<ng-template #switchViewButton>
    <ui-button type="outline" (click)="switchView()"
        ><mat-icon svgIcon="refresh"></mat-icon
        >{{ (showTableView ? 'payroll.run.table.classicView' : 'payroll.run.table.tableView') | translate }}</ui-button
    >
</ng-template>
